import { useRouter } from 'next/router';
import EditorImg from 'lowcode/components/EditorImg';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import Header from '@/components/EcoCredits/CommonElement/Header';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';

export interface CTACardProps {
    title?: string;
    subTitle: string;
    cta: string;
    href: string;
    pc: string;
    h5: string;
}

export default function CTACard(props: Partial<CTACardProps>) {
    const { title, subTitle, cta, pc, h5, href } = props;
    const { t } = useLang('ecocredits');
    const router = useRouter();
    const { locale } = getLocal();

    return (
        <div className={styles.CTACard} id="CTA_Card">
            <Header title={t('card.title')} desc={t('card.subtitle')} />
            <div className="CTACard_content">
                <EditorImg pc={pc} h5={h5} alt={cta} aria-label={cta} />
                <div className="card_text">
                    <div className="list_block">
                        <div className="b_row1">{t('card.you')}</div>
                        <ol>
                            <li>{t('card.you_col1')}</li>
                            <li>{t('card.you_col2')}</li>
                            <li>{t('card.you_col3')}</li>
                        </ol>
                    </div>
                    <div className="list_block">
                        <div className="b_row1">{t('card.your')}</div>
                        <ol>
                            <li>{t('card.your_col1')}</li>
                        </ol>
                    </div>
                    <div className="btn-wrap">
                        <div
                            className="button"
                            onClick={() => {
                                href && router.push(href);
                            }}
                        >
                            {t('card.button')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
